export function nameOf<T>(key: keyof T, _instance?: T): keyof T {
  return key;
}
